<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">订单管理</span>
      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
      <div>
        任务页数：指原文件页数，如果打印输出尺寸为A3，任务页数=原文件页数*2
        <p>
          出纸页数：打印机实际出纸页数，换算成A4单面进行展示，A3和双面自动2倍，已去除空白页（比如原稿3页打印1份双面，出纸数即为3页）
        </p>
      </div>
    </div>

    <div class="filter-box">
      <div class="item_box">
        <span class="subtitle">用户类型:</span>
        <Select
          class="select"
          @on-change="user_type_change"
          v-model="user_type"
          :multiple="user_type_multiple"
        >
          <Option value="-1">全部</Option>
          <Option
            v-for="(item, index) in Object.keys(user_type_list)"
            :key="index"
            :value="item"
            >{{ user_type_list[item].name }}</Option
          >
        </Select>
        <span class="subtitle" style="margin-left: 20px">消费类型:</span>
        <Select
          class="select"
          @on-change="job_type_change"
          v-model="job_type"
          :multiple="job_type_multiple"
        >
          <Option value="-1">全部</Option>
          <Option
            v-for="(item, index) in Object.keys(job_type_list)"
            :key="index"
            :value="item"
            >{{ job_type_list[item].name }}</Option
          >
        </Select>
        <span class="subtitle" style="margin-left: 20px">设备品牌:</span>
        <Select class="select" v-model="machineTypeParams" multiple>
          <Option v-for="(item, index) in machineTypesGroup" :key="index" :value="item">{{
            item
          }}</Option>
        </Select>

        <!-- <span class="subtitle" style="margin-left: 20px">支付方式:</span>
        <Select
          class="select"
          @on-change="money_type_change"
          v-model="money_type"
          :multiple="money_type_multiple"
        >
          <Option value="-1">全部</Option>
          <Option
            v-for="(item, index) in Object.keys(money_type_list)"
            :key="index"
            :value="item"
            >{{ money_type_list[item].name }}</Option
          >
        </Select> -->
      </div>
      <div class="item_box">
        <span class="subtitle">订单状态:</span>
        <Select class="select" v-model="order_type">
          <Option :value="-1">全部</Option>
          <Option
            v-for="(item, index) in order_type_list"
            :key="index"
            :value="item.val"
            >{{ item.name }}</Option
          >
        </Select>

        <Input
          v-model.trim="page.value1"
          placeholder="请输入"
          class="select"
          style="margin-left: 20px; width: 340px"
        >
          <Select v-model="page.select_key1" slot="prepend" style="width: 100px">
            <Option value="sn">序列号</Option>
            <Option value="site_name">设备站点</Option>
            <Option value="agent_name">合作伙伴</Option>
          </Select>
        </Input>

        <Input v-model.trim="page.value2" style="margin-left: 20px; width: 340px">
          <Select v-model="page.select_key2" slot="prepend" style="width: 100px">
            <Option value="pay_no">订单号</Option>
            <!-- <Option value="aid_pay_no">商户单号</Option> -->
            <!-- <Option value="channel_id">交易单号</Option> -->
            <Option value="id">订单ID</Option>
            <Option value="account">教师ID</Option>
            <Option value="tel">手机/员工号</Option>
            <!-- <Option value="color">颜色</Option>
            <Option value="duplex">单双面</Option>-->
          </Select>
        </Input>
      </div>

      <div class="item_box">
        <span class="subtitle">作业时间:</span>
        <DatePicker
          type="date"
          v-model="page.start"
          @on-change="changeDate"
          placeholder="开始时间"
          style="width: 120px"
        >
        </DatePicker>
        <span style="margin-left: 5px">至</span>
        <DatePicker
          type="date"
          v-model="page.end"
          @on-change="changeDate"
          placeholder="结束时间"
          style="width: 130px; margin-left: 5px"
        ></DatePicker>
        <RadioGroup
          type="button"
          style="margin-left: 20px"
          v-model="radio"
          @on-change="onChangeSelectData"
        >
          <Radio label="0">
            <span>今日</span>
          </Radio>
          <Radio label="1">
            <span>本月</span>
          </Radio>
          <Radio label="2">
            <span>上月</span>
          </Radio>
        </RadioGroup>
        <!-- <span class="subtitle" style="margin-left: 20px;">设备类型:</span>
        <Select class="select" v-model="order_type">
          <Option :value="-1">全部</Option>
          <Option :value="1">云知印</Option>
          <Option :value="3">云知印mini</Option>
        </Select> -->
      </div>

      <div class="bottom">
        <span class="btn-filter" @click="getData(1)">筛选</span>
        <span class="btn" @click="reset">清空</span>
        <Poptip title="导出Excel" placement="right" trigger="hover">
          <!-- <Button type="primary" style="margin: 0 5px 1px 0">导出Excel</Button> -->
          <span class="btn">导出报表</span>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
        <Button
          v-if="!agent.tp"
          :disabled="!delIds.length"
          type="error"
          @click="delJobs"
          style="margin-left: 10px"
          >删除已选</Button
        >

        <!-- <Button
          v-if="!agent.tp"
          type="warning"
          @click="modalRefunds.visible = true"
          style="margin-left: 10px"
          >退款</Button
        > -->
      </div>
    </div>

    <div style="position: relative">
      <Table
        size="small"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
        @on-selection-change="handleSelection"
      />
      <div class="t-right" style="margin-top: 10px">
        <!-- <p>
          <span class="total_title">总到账:</span>
          <span class="total">
            {{ parseFloat(total_data.result_money - total_data.return_money).toFixed(2) }}
          </span>
          <span class="total_title">游客消费:</span>
          <span class="total">
            {{ parseFloat(total_data.visitor).toFixed(2) }}
          </span>
          <span class="total_title">会员消费:</span>
          <span class="total">
            {{ parseFloat(total_data.user).toFixed(2) }}
          </span>
          <span class="total_title">退款:</span>
          <span class="total">
            {{ parseFloat(total_data.return_money).toFixed(2) }}
          </span>
        </p> -->
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :current="page.p + 1"
          :total="total"
          :page-size-opts="pageSizeOpts"
          :page-size="10"
          show-elevator
          show-sizer
          show-total
        />
      </div>
      <Spin fix v-if="tableLoading">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>
    <Modal width="400" title="订单退款" v-model="modal.visible">
      <div style="margin-left: 30px">
        退款金额:
        <InputNumber
          :active-change="false"
          :precision="2"
          style="margin-left: 15px; width: 140px"
          :max="modal.data.result_money - modal.data.return_money"
          :min="0.01"
          v-model="modal.money"
          placeholder="退款金额"
          :step="0.01"
        >
        </InputNumber>
      </div>
      <div style="color: #ccc; font-size: 12px; margin-left: 110px; margin-top: 10px">
        最大退款金额:
        {{ parseFloat(modal.data.result_money - modal.data.return_money).toFixed(2) }}
      </div>
      <div slot="footer">
        <Button @click="modal.visible = false" stlye="margin-right:5px">取消</Button>
        <Button
          @click="returnMoney"
          type="primary"
          v-preventReClick
          :loading="modal.loading"
          >确定</Button
        >
      </div>
    </Modal>

    <Modal width="400" title="订单退款" v-model="modalRefunds.visible">
      <div style="margin-left: 30px">
        订单号:
        <Input
          style="margin-left: 15px; width: 250px"
          v-model="modalRefunds.data.pay_no"
          placeholder="请输入订单号"
        />
        <div style="color: red; font-size: 12px; margin-top: 10px">
          该退款方式只支持搜索不到的18位纯数字订单号，如：230506116561480981
        </div>
      </div>
      <div slot="footer">
        <Button @click="modalRefunds.visible = false" stlye="margin-right:5px"
          >取消</Button
        >
        <Button
          @click="handlerErrorJobRefund"
          type="primary"
          v-preventReClick
          :loading="modalRefunds.loading"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SeniorSearch from "_c/senior_search";
import excel from "@/libs/excel";
import { monDiff, verifyDate } from "@/libs/util";
function nowInDateBetwen(startdate, enddate) {
  var startD = new Date(Date.parse(startdate.replace(/-/g, "/")));
  var endD = new Date(Date.parse(enddate.replace(/-/g, "/")));
  var days = parseInt((endD.getTime() - startD.getTime()) / (1000 * 60 * 60 * 24));
  if (days > 31) return false;
  return true;
}

const machineTypes = ["云知印", "智能运维", "常规运维", "云知印mini"];
export default {
  components: {
    SeniorSearch,
  },
  data() {
    return {
      tableLoading: false,
      modal: {
        visible: false,
        data: {},
        money: 0,
        loading: false,
      },
      modalRefunds: {
        visible: false,
        data: { pay_no: "" },
        loading: false,
      },
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
          fixed: "left",
        },
        { fixed: "left", width: 100, key: "id", title: "订单ID", search: true },
        {
          fixed: "left",
          width: 135,
          key: "result_time",
          title: "作业时间",
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.result_time ? this.$moment(data.row.result_time) : "-"
            );
          },
        },
        {
          fixed: "left",
          width: 180,
          key: "order_no",
          title: "订单号",
          search: true,
        },
        /* {
          fixed: "left",
          width: 180,
          key: "pay_no",
          title: "订单号",
          search: true,
        }, */
        /* {
          width: 200,
          key: "aid_pay_no",
          title: "商户订单号",
          search: true,
          render: (h, data) => {
            return h("span", {}, data.row.aid_pay_no ? data.row.aid_pay_no : "-");
          },
        }, */
        /* {
          width: 260,
          key: "channel_id",
          title: "交易单号",
          search: true,
          render: (h, data) => {
            return h("span", {}, data.row.channel_id ? data.row.channel_id : "-");
          },
        }, */
        /*  {
          width: 100,
          key: "meter_str",
          title: "设备类型",
          search: true,
        }, */
        {
          width: 118,
          key: "sn",
          title: "设备序列号",
          search: true,
        },
        {
          width: 195,
          key: "agent_name",
          title: "合作伙伴",
          search: true,
          tooltip: true,
        },
        {
          width: 120,
          key: "site_name",
          title: "站点",
          search: true,
        },
        {
          width: 90,
          key: "job_status",
          title: "状态",
          render: (h, data) => {
            // -1未操作 初始状态\n0 订单失败\n1 打印完成\n2 失败异常 未退款\n3 解锁文件\n4 退款成功\n5 删除\n6 锁定 正在打印 或 已付款\n7 退款失败
            let status = {
              "-1": "未操作",
              0: "订单失败",
              1: "订单完成",
              2: "订单异常未退款",
              4: "退款成功",
              5: "删除",
              6: "进行中",
              7: "退款失败",
              8: "订单结束",
            };
            return h("span", {}, status[`${data.row.job_status}`]);
          },
          search: true,
          searchOption: {
            type: "select",
            vals: [
              { name: "未处理", val: -1 },
              { name: "订单失败", val: 0 },
              { name: "订单完成", val: 1 },
              { name: "订单异常未退款", val: 2 },
              { name: "退款成功", val: 4 },
              { name: "删除", val: 5 },
              { name: "退款失败", val: 7 },
            ],
          },
        },
        {
          width: 95,
          key: "user_type",
          title: "用户类型",
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.user_id ? (data.row.staff_id ? "教师" : "个人会员") : "游客"
            );
          },
        },
        {
          width: 100,
          key: "user_name",
          title: "教师姓名",
          render: (h, data) => {
            return h("span", {}, data.row.user_name || "-");
          },
        },
        {
          width: 150,
          key: "account",
          title: "教师ID",
          render: (h, data) => {
            return h("span", {}, data.row.account || "-");
          },
        },
        {
          width: 110,
          key: "tel",
          title: "手机/账号",
          render: (h, data) => {
            if (this.agent.tp && !data.row.staff_id && data.row.tel) {
              data.row.tel =
                data.row.tel.substring(0, parseInt(data.row.tel.length / 3)) +
                "****" +
                data.row.tel.substring(
                  parseInt(data.row.tel.length / 3) + 4,
                  data.row.tel.length
                );
            }
            return h("span", {}, data.row.tel ? data.row.tel : "-");
          },
          search: true,
        },
        {
          width: 110,
          key: "tel",
          title: "卡号",
          render: (h, data) => {
            return h("span", {}, data.row.idcard ? data.row.idcard : "-");
          },
          search: true,
        },
        /* {
          width: 100,
          key: "money",
          title: "订单金额",
          renderHeader: (h, data) => {
            return h("div", {}, [
              h("span", "订单金额"),
              h(
                "Tooltip",
                {
                  props: {
                    content: "订单金额",
                    transfer: true,
                  },
                },
                [
                  h("Icon", {
                    props: {
                      type: "ios-alert-outline",
                    },
                    style: {
                      margin: "0 0 2.5px 2px",
                    },
                  }),
                ]
              ),
            ]);
          },
          search: true,
        },
        { width: 100, key: "coupon_money", title: "券抵扣", search: true },
        { width: 100, key: "activity_money", title: "设备限免", search: true },
        {
          width: 100,
          key: "result_money",
          title: "支付金额",
          renderHeader: (h, data) => {
            return h("div", {}, [
              h("span", "支付金额"),
              h(
                "Tooltip",
                {
                  props: {
                    content: "支付金额",
                    transfer: true,
                  },
                },
                [
                  h("Icon", {
                    props: {
                      type: "ios-alert-outline",
                    },
                    style: {
                      margin: "0 0 2.5px 2px",
                    },
                  }),
                ]
              ),
            ]);
          },
          search: true,
        },
        { width: 100, key: "return_money", title: "退款金额", search: true },
        {
          width: 100,
          key: "get_money",
          title: "到账金额",
          renderHeader: (h, data) => {
            return h("div", {}, [
              h("span", "到账金额"),
              h(
                "Tooltip",
                {
                  props: {
                    content: "到账金额",
                    transfer: true,
                  },
                },
                [
                  h("Icon", {
                    props: {
                      type: "ios-alert-outline",
                    },
                    style: {
                      margin: "0 0 2.5px 2px",
                    },
                  }),
                ]
              ),
            ]);
          },
          render: (h, data) => {
            return h(
              "span",
              parseFloat(data.row.result_money - data.row.return_money).toFixed(2)
            );
          },
        },
        {
          width: 100,
          key: "collection",
          title: "收款方式",
          render: (h, data) => {
            return h("span", "云知印");
          },
        }, */
        {
          width: 90,
          key: "job_type",
          title: "类型",
          render: (h, data) => {
            const res = h("span", {}, this.job_type_list[data.row.job_type].name);
            return res;
          },
        },
        {
          width: 120,
          key: "file_status",
          title: "上传状态",
          render: (h, data) => {
            const res = [];
            if (data.row.job_type === 3) {
              //扫描文件 显示状态
              const fileStatus = {
                0: {
                  color: "blue",
                  text: "上传中",
                },
                1: {
                  color: "blue",
                  text: "上传中",
                },
                2: {
                  color: "green",
                  text: "上传成功",
                },
                3: {
                  color: "red",
                  text: "上传失败",
                },
              };
              res.push(
                h(
                  "Tag",
                  { props: { color: fileStatus[data.row.file_status].color } },
                  fileStatus[data.row.file_status].text
                )
              );
            } else {
              res.push(h("span", {}, "-"));
            }
            return res;
          },
        },
        {
          width: 140,
          key: "file_real_name",
          title: "任务名称",
          tooltip: true,
          search: true,
        },
        {
          width: 100,
          key: "printed_copies",
          title: "任务份数",
          tooltip: true,
          render: (h, data) => {
            let printed_copies = data.row.printed_copies;
            if (data.row.job_type === 3) {
              printed_copies = "-";
            }
            return h("span", printed_copies);
          },
        },
        {
          width: 100,
          key: "printed_pages",
          title: "任务页数",
          render: (h, data) => {
            let printed_pages = data.row.printed_pages;
            if (data.row.job_type === 3) {
              printed_pages = data.row.result_pages;
            }
            return h("span", printed_pages);
          },
          renderHeader: (h, data) => {
            return h("div", {}, [
              h("span", "任务页数"),
              h(
                "Tooltip",
                {
                  props: {
                    content: "指打印任务原文件页数",
                    transfer: true,
                  },
                },
                [
                  h("Icon", {
                    props: {
                      type: "ios-alert-outline",
                    },
                    style: {
                      margin: "0 0 2.5px 2px",
                    },
                  }),
                ]
              ),
            ]);
          },
        },
        {
          width: 90,
          key: "copies",
          title: "出纸份数",
          search: true,
          render: (h, data) => {
            let copies = data.row.copies;

            if (data.row.job_type === 3) {
              copies = "-";
            }
            return h("span", copies);
          },
        },
        {
          width: 100,
          key: "single_pages",
          title: "出纸页数",
          render: (h, data) => {
            let single_pages = data.row.single_pages;

            if (data.row.job_type === 3 && data.row.job_status === 0) {
              single_pages = "-";
            }
            return h("span", single_pages);
          },
          renderHeader: (h, data) => {
            return h("div", {}, [
              h("span", "出纸页数"),
              h(
                "Tooltip",
                {
                  props: {
                    transfer: true,
                  },
                },
                [
                  h("Icon", {
                    props: {
                      type: "ios-alert-outline",
                    },
                    style: {
                      margin: "0 0 2.5px 2px",
                    },
                  }),
                  h(
                    "span",
                    {
                      slot: "content",
                      style: {
                        whiteSpace: "normal",
                      },
                    },
                    "实际出纸页数，按A4单面算"
                  ),
                ]
              ),
            ]);
          },
          search: true,
        },
        // {
        //   width: 100,
        //   key: "result_pages",
        //   title: "出纸页数",
        //   render: (h, data) => {
        //     let result_pages = data.row.result_pages;
        //     if (data.row.duplex) {
        //       result_pages = result_pages * 2;
        //     }
        //     if (data.row.sizes === "A3" || data.row.sizes === "a3") {
        //       result_pages = result_pages * 2;
        //     }
        //     if (data.row.job_type === 3 && data.row.file_status === 3) {
        //       result_pages = "-";
        //     }
        //     return h("span", result_pages);
        //   },
        //   renderHeader: (h, data) => {
        //     return h("div", {}, [
        //       h("span", "出纸页数"),
        //       h(
        //         "Tooltip",
        //         {
        //           props: {
        //             transfer: true,
        //           },
        //         },
        //         [
        //           h("Icon", {
        //             props: {
        //               type: "ios-alert-outline",
        //             },
        //             style: {
        //               margin: "0 0 2.5px 2px",
        //             },
        //           }),
        //           h(
        //             "span",
        //             {
        //               slot: "content",
        //               style: {
        //                 whiteSpace: "normal",
        //               },
        //             },
        //             "实际出纸页数，按A4单面算"
        //           ),
        //         ]
        //       ),
        //     ]);
        //   },
        //   search: true,
        // },
        /* {
          width: 100,
          key: "pages",
          title: "文件页数",
          renderHeader: (h, data) => {
            return h("div", {}, [
              h("span", "文件页数"),
              h(
                "Tooltip",
                {
                  props: {
                    content: "打印指原文件页数，扫描指原稿张数",
                    transfer: true,
                  },
                },
                [
                  h("Icon", {
                    props: {
                      type: "ios-alert-outline",
                    },
                    style: {
                      margin: "0 0 2.5px 2px",
                    },
                  }),
                ]
              ),
            ]);
          },
          search: true,
        }, */

        /* {
          width: 90,
          key: "duplex",
          title: "单双面",
          renderHeader: (h, data) => {
            // return h("span", data.row.duplex ? "双面" : "单面");

            return h("div", {}, [
              h("span", "单双面"),
              h(
                "Tooltip",
                {
                  props: {
                    transfer: true,
                  },
                },
                [
                  h("Icon", {
                    props: {
                      type: "ios-alert-outline",
                    },
                    style: {
                      margin: "0 0 2.5px 2px",
                    },
                  }),
                  h(
                    "span",
                    {
                      slot: "content",
                      style: {
                        whiteSpace: "normal",
                      },
                    },
                    "打印复印订单指出纸，扫描订单指原稿"
                  ),
                ]
              ),
            ]);
          },
          render: (h, data) => {
            return h("span", data.row.duplex ? "双面" : "单面");
          },
          search: true,
        }, */
        /* {
          width: 90,
          key: "scope",
          title: "打印范围",
          search: false,
          render: (h, data) => {
            return h(
              "span",
              data.row.page_start >= 0 &&
                data.row.page_end &&
                data.row.page_end - data.row.page_start + 1 != data.row.pages
                ? data.row.page_start + " - " + data.row.page_end
                : "-"
            );
          },
        }, */
        { width: 90, key: "sizes", title: "尺寸", search: true },
        {
          width: 90,
          key: "color",
          title: "颜色",
          render: (h, data) => {
            return h("span", {}, data.row.color ? "彩色" : "黑白");
          },
          search: true,
        },
        /* {
          width: 100,
          key: "plan_total_pages",
          title: "计划页数",
          renderHeader: (h, data) => {
            return h("div", {}, [
              h("span", "计划页数"),
              h(
                "Tooltip",
                {
                  props: {
                    transfer: true,
                  },
                },
                [
                  h("Icon", {
                    props: {
                      type: "ios-alert-outline",
                    },
                    style: {
                      margin: "0 0 2.5px 2px",
                    },
                  }),
                  h(
                    "span",
                    {
                      slot: "content",
                      style: {
                        whiteSpace: "normal",
                      },
                    },
                    "计划打印页数，等于文件页数"
                  ),
                ]
              ),
            ]);
          },
          search: true,
        }, */

        /* {
          width: 100,
          key: "money_type",
          title: "支付方式",
          render: (h, data) => {
            let temp = {
              "-1": "待定",
              0: "钱包",
              1: "微信",
              2: "支付宝",
              3: "免费",
              4: "学校钱包",
              5: "员工配额",
              6: "员工钱包",
            };
            return h("span", {}, temp[`${data.row.money_type}`]);
          },
        }, */
      ],
      data: [],
      page: {
        p: 0,
        l: 10,
        start: "",
        end: "",
        select_key1: "sn",
        value1: "",
        select_key2: "pay_no",
        value2: "",
        search: {},
      },
      radio: "0",
      page_global: "",
      date: [],
      total: 0,
      total_data: {},
      pageSizeOpts: [10, 50, 100, 150],
      user_type_list: {
        // "-1": { name: "全部" },
        // 0: { name: "游客" },
        1: { name: "个人会员" },
        2: { name: "教师" },
      },
      user_type: "-1",
      user_type_multiple: false,

      job_type_list: {
        // "-1": { name: "全部" },
        1: { name: "打印" },
        // 2: { name: "复印" },
        3: { name: "扫描" },
        // 5: { name: "冲印" },
        // 6: { name: "证件" },
      },
      job_type: "-1",
      job_type_multiple: false,

      money_type_list: {
        "-1": { name: "" },
        0: { name: "钱包" },
        1: { name: "微信" },
        2: { name: "支付宝" },
        3: { name: "免费" },
        4: { name: "学校钱包" },
        5: { name: "员工配额" },
        // 6: { name: "临时配额" },
        6: { name: "员工钱包" },
      },
      money_type: "-1",
      money_type_multiple: false,

      order_type_list: [
        // { name: "进行中", val: -1 },
        { name: "订单失败", val: 0 },
        { name: "订单完成", val: 1 },
        { name: "进行中", val: 6 },
        { name: "退款成功", val: 4 },
        // { name: "退款失败", val: 7 },
        // { name: "订单结束", val: 8 },
        // { name: "删除", val: 5 },
      ],
      order_type: -1,
      is_staff: true,
      delIds: [],
      machineTypesGroup: [],
      machineTypeParams: [],
    };
  },
  mounted() {
    let now = new Date();
    this.page.start = this.$moment(now, "YYYY-MM-DD");
    this.page.end = this.$moment(now, "YYYY-MM-DD");

    if (!this.agent.tp) {
      // this.order_type_list.push({ name: "订单结束", val: 8 });
      // this.order_type_list.push({ name: "订单失败", val: 0 });
      this.order_type_list.push({ name: "退款失败", val: 7 });
      /* this.columns.push({
        fixed: "right",
        width: 180,
        key: "operator",
        title: "操作",
        export_ignore: true,
        render: (h, data) => {
          let arr = [];
          if (data.row.result_money !== data.row.return_money) {
            const returnMoney = h(
              "Button",
              {
                props: { size: "small", type: "primary" },
                on: {
                  click: () => {
                    this.modal = {
                      visible: true,
                      data: data.row,
                      money: null,
                    };
                    this.modal.money = parseFloat(
                      data.row.result_money - data.row.return_money
                    );
                  },
                },
                style: {
                  marginRight: "10px",
                },
              },
              "退款"
            );
            arr.push(returnMoney);
          }

          if (data.row.job_status === 1 && !data.row.is_transfer) {
            const jobOver = h(
              "Button",
              {
                props: { size: "small", type: "warning" },
                on: {
                  click: () => {
                    this.JobOver({ id: data.row.id })
                      .then((res) => {
                        if (res.status) {
                          this.$Message.success("操作成功");
                          this.getData();
                        }
                      })
                      .catch((e) => {
                        this.$Message.success("系统异常");
                      });
                  },
                },
                style: {
                  marginRight: "10px",
                },
              },
              "结束"
            );

            arr.push(jobOver);
          }

          return arr;
        },
      }); */
    } else {
      //隐藏出纸份数和页数
      // const columns = [...this.columns];
      // console.log("columns", columns);
      // const newColumns = columns.filter(
      //   (item) => item.key !== "copies" && item.key !== "single_pages"
      // );
      // this.columns = newColumns;
    }
    this.GetMachineTypeGroup().then((res) => {
      this.machineTypesGroup = res.map((item) => {
        return item.brand;
      });
    });
    this.getData();
  },
  methods: {
    exportData(is_all) {
      let time =
        this.$moment(this.page.start, "YYYY-MM-DD") +
        "至" +
        this.$moment(this.page.end, "YYYY-MM-DD");
      let params = {
        title: [],
        key: [],
        autoWidth: true,
        filename: "订单记录-" + time,
      };
      this.columns.map((item) => {
        if (item.export_ignore) {
          return;
        }
        params.title.push(item.title);
        params.key.push(item.key);
      });
      console.log("params", params);
      if (is_all) {
        let cond = JSON.parse(JSON.stringify(this.getDataParams()));
        if (cond.start && cond.end) {
          let DateStatus = nowInDateBetwen(cond.start, cond.end, new Date());
          if (!DateStatus) {
            this.$Message.error("最多支持导出31天数据");
            return false;
          }
        }
        cond.l = 1000000;
        cond.p = 0;
        this.tableLoading = true;
        this.JobList(cond).then((res) => {
          this.tableLoading = false;
          params.data = this.formatExportData(res.data);
          excel.export_array_to_excel(params);
        });
      } else {
        params.data = this.formatExportData(this.data);
        excel.export_array_to_excel(params);
      }
    },
    formatExportData(data) {
      let result = JSON.parse(JSON.stringify(data));
      let job_status = {
        "-1": "订单创建",
        0: "订单失败",
        1: "订单完成",
        2: "订单异常未退款",
        4: "退款成功",
        5: "删除",
        6: "进行中",
        7: "退款失败",
        8: "订单结束",
      };
      result.map((item) => {
        if (item.job_type === 3) {
          item.printed_copies = "-";
          item.printed_pages = item.result_pages;
          item.copies = "-";
        }
        let result_pages = item.result_pages;

        if (item.duplex) {
          result_pages = result_pages * 2;
        }
        if (item.sizes === "A3" || item.sizes === "a3") {
          result_pages = result_pages * 2;
        }
        if (item.job_type === 3 && item.file_status === 3) {
          result_pages = "-";
        }
        item.result_pages = result_pages;
        if (item.job_type === 3 && item.file_status === 3) {
          item.result_pages = "-";
        }

        if (item.job_type === 3 && item.job_status === 0) {
          item.single_pages = "-";
        }

        const fileStatus = {
          0: {
            color: "blue",
            text: "上传中",
          },
          1: {
            color: "blue",
            text: "上传中",
          },
          2: {
            color: "green",
            text: "上传成功",
          },
          3: {
            color: "red",
            text: "上传失败",
          },
        };
        if (item.job_type === 3) {
          item.file_status = fileStatus[item.file_status].text;
        } else {
          item.file_status = "-";
        }

        item.collection = "云知印";
        // item.get_money = parseFloat(item.result_money - item.return_money).toFixed(2);
        item.get_money = item.result_money - item.return_money;
        item.result_time = this.$moment(item.result_time);
        item.user_type = item.user_id ? (item.staff_id ? "会员(学校)" : "会员") : "游客";
        item.job_type = this.job_type_list[item.job_type].name;
        item.money_type = this.money_type_list[item.money_type].name;
        item.job_status = job_status[`${item.job_status}`];
        item.color = item.color ? "彩色" : "黑白";
        item.scope =
          item.page_start >= 0 &&
          item.page_end &&
          item.page_end - item.page_start + 1 != item.pages
            ? item.page_start + " - " + item.page_end
            : "-";
        item.duplex = item.duplex ? "双面" : "单面";
        if (this.agent.tp && !item.staff_id && item.tel) {
          item.tel =
            item.tel.substring(0, parseInt(item.tel.length / 3)) +
            "****" +
            item.tel.substring(parseInt(item.tel.length / 3) + 4, item.tel.length);
        }
      });
      return result;
    },
    globalSearch(value) {
      this.page_global = value;
      this.getData();
    },
    getParams(cond) {
      this.page.search = cond;
      this.page.p = 0;
      this.getData();
    },
    returnMoney() {
      // this.modal.loading = true;
      this.$set(this.modal, "loading", true);
      if (
        this.modal.data.money_type === 1 ||
        this.modal.data.money_type === 2 ||
        this.modal.data.money_type === 7
      ) {
        this.JobTotalMoney({ order_no: this.modal.data.order_no }).then((re) => {
          if (this.modal.data.money_type === 7 || this.modal.data.aid_pay_no) {
            this.RefundJob({
              id: this.modal.data.id,
              user_id: this.modal.data.user_id,
              machine_id: this.modal.data.machine_id,
              agent_id: this.modal.data.agent_id,
              order_no: this.modal.data.order_no,
              totalMoney: re,
              returnMoney: this.modal.money,
              append: true,
            }).then((res) => {
              if (res) {
                this.$Message.success("退款成功");
              } else {
                this.$Message.error("退款失败");
              }
              this.getData();
              this.modal.visible = false;
              this.modal.loading = false;
            });
          } else if (this.modal.data.money_type === 1) {
            // 微信
            this.WXReturnMoney({
              id: this.modal.data.id,
              user_id: this.modal.data.user_id,
              machine_id: this.modal.data.machine_id,
              agent_id: this.modal.data.agent_id,
              order_no: this.modal.data.order_no,
              totalMoney: re,
              returnMoney: this.modal.money,
              append: true,
            }).then((res) => {
              if (res) {
                this.$Message.success("退款成功");
              } else {
                this.$Message.error("退款失败");
              }
              this.getData();
              this.modal.visible = false;
              this.modal.loading = false;
            });
          } else {
            // 支付宝
            this.ALIReturnMoney({
              id: this.modal.data.id,
              user_id: this.modal.data.user_id,
              machine_id: this.modal.data.machine_id,
              agent_id: this.modal.data.agent_id,
              order_no: this.modal.data.order_no,
              totalMoney: re,
              returnMoney: this.modal.money,
              append: true,
            }).then((res) => {
              if (res) {
                this.$Message.success("退款成功");
              } else {
                this.$Message.error("退款失败");
              }
              this.getData();
              this.modal.visible = false;
              this.modal.loading = false;
            });
          }
        });
      } else {
        this.JobReturnMoney({
          id: this.modal.data.id,
          user_id: this.modal.data.user_id,
          machine_id: this.modal.data.machine_id,
          agent_id: this.modal.data.agent_id,
          money: this.modal.money,
          staff_id: this.modal.data.staff_id,
          money_type: this.modal.data.money_type,
        }).then((res) => {
          if (res) {
            this.$Message.success("退款成功");
            this.getData();
            this.modal.visible = false;
            this.modal.loading = false;
          }
        });
      }
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    staffChange() {
      this.getData();
    },
    user_type_change(user_type) {
      if (user_type.indexOf("-1") >= 0 || user_type.length === 0) {
        this.user_type_multiple = false;
        this.user_type = "-1";
      } else {
        this.user_type_multiple = true;
      }
    },
    job_type_change(job_type) {
      if (job_type.indexOf("-1") >= 0 || job_type.length === 0) {
        this.job_type_multiple = false;
        this.job_type = "-1";
      } else {
        this.job_type_multiple = true;
      }
    },
    money_type_change(money_type) {
      if (money_type.indexOf("-1") >= 0 || money_type.length === 0) {
        this.money_type_multiple = false;
        this.money_type = "-1";
      } else {
        this.money_type_multiple = true;
      }
    },
    getDataParams() {
      this.page.where = "";
      this.page.job_type = [];
      this.page.money_type = [];
      if (this.user_type !== "-1") {
        let temp;
        if (typeof this.user_type == "string") {
          temp = this.user_type;
        } else {
          temp = this.user_type.sort().join(",");
        }
        // "0":{name: "游客"},
        // "1":{name: "会员"},
        // "2":{name: "会员(学校)"}
        if (temp === "0,1") {
          this.page.where = " staff_id is null";
        } else if (temp === "0,2") {
          this.page.where = " (user_id is null or staff_id is not null)";
        } else if (temp === "1,2") {
          this.page.where = " user_id is not null";
        } else if (temp === "0") {
          this.page.where = " user_id is null";
        } else if (temp === "1") {
          this.page.where = " user_id is not null and staff_id is null";
        } else if (temp === "2") {
          this.page.where = " staff_id is not null";
        }
      }
      if (this.job_type === "-1") {
        this.page.job_type = [1, 2, 3, 5, 6];
      } else {
        this.page.job_type =
          this.job_type instanceof Array ? this.job_type : [this.job_type];
      }

      if (this.money_type === "-1") {
        this.page.money_type = [-1, 1, 2, 0, 3, 4, 5, 6];
      } else {
        this.page.money_type =
          this.money_type instanceof Array ? this.money_type : [this.money_type];
      }
      //合并筛选条件
      let temp = [];
      if (this.order_type >= 0) {
        temp.push({
          name: "job_status",
          val: this.order_type,
        });
      }
      if (this.page.value1) {
        temp.push({
          name: this.page.select_key1,
          val: this.page.value1,
        });
      }
      if (this.page.value2) {
        temp.push({
          name: this.page.select_key2,
          val: this.page.value2,
        });
      }
      this.page.search = {};
      temp.map((item) => {
        this.page.search[item.name] = item.val;
      });
      console.log("筛选条件", this.page.search);

      let cond = JSON.parse(JSON.stringify(this.page));
      cond.start = this.$moment(this.page.start, "YYYY-MM-DD");
      cond.end = this.$moment(this.page.end, "YYYY-MM-DD");
      this.total_data = {
        visitor: 0,
        user: 0,
        result_money: 0,
        return_money: 0,
      };
      // cond.global = this.page_global; //关键字
      // cond.is_staff = this.is_staff ? 0 : 1; //是否是员工
      console.log(cond);
      return cond;
    },
    getData(filter) {
      if (filter) {
        this.page.p = 0;
        if (verifyDate(this.page.start, this.page.end)) {
          this.$Message.error("开始时间不能大于结束时间");
          return;
        }
        if (this.page.start && this.page.end) {
          /* let start = new Date(this.page.start).getMonth() + 1;
          let end = new Date(this.page.end).getMonth() + 1;
          console.log(start, end);
          //如果时间跨度超过6个月就提示
          if (end - start > 12) {
            this.$Message.error("筛选的时间跨度不能超过12个月");
            return;
          } */
          if (monDiff(this.page.start, this.page.end) > 12) {
            //如果时间跨度超过一年就提示
            this.$Message.error("筛选的时间跨度不能超过12个月");
            return;
          }
        }
      }

      this.delIds = [];

      let cond = JSON.parse(JSON.stringify(this.getDataParams()));
      console.log("cond", cond);
      if (cond.search.color && cond.search.color === "彩色") cond.search.color = 1;
      if (cond.search.color && cond.search.color === "黑白") cond.search.color = 0;
      if (this.machineTypeParams.length) {
        cond.brand = this.machineTypeParams;
      }
      this.tableLoading = true;
      this.JobList(cond).then((res) => {
        this.tableLoading = false;
        res.data.map((item) => {
          this.total_data.result_money += item.result_money || 0;
          this.total_data.return_money += item.return_money || 0;
          // item.total_pages = item.total_pages * item.copies;
          if (item.user_id) {
            this.total_data.user += item.result_money || 0;
          } else {
            this.total_data.visitor += item.result_money || 0;
          }
          item.meter_str = machineTypes[item.meter];
        });
        this.data = res.data;
        this.total = res.total;
      });
    },
    onChangeSelectData(e) {
      switch (e) {
        case "0": //今日
          let now = new Date();
          this.page.start = this.$moment(now, "YYYY-MM--DD");
          this.page.end = this.$moment(now, "YYYY-MM--DD");
          break;
        case "1": //本月
          this.curMonth(true);
          break;
        case "2": //上月
          this.curMonth();
          break;
      }
    },
    curMonth(isCur) {
      let now = new Date();
      let a = isCur ? 1 : 0;
      let last = new Date(now.getFullYear(), now.getMonth() + a, 0);
      this.page.start = this.$moment(last, "YYYY-MM") + "-01";
      this.page.end = this.$moment(last, "YYYY-MM-DD");
    },
    changeDate() {
      this.radio = "";
    },
    reset() {
      this.page = {
        p: 0,
        l: 10,
        start: "",
        end: "",
        select_key1: "sn",
        value1: "",
        select_key2: "pay_no",
        value2: "",
        search: {},
      };
      this.order_type = -1;
      this.money_type = "-1";
      this.job_type = "-1";
      this.user_type = "-1";
      this.rado = "0";
      let now = new Date();
      this.page.start = this.$moment(now, "YYYY-MM-DD");
      this.page.end = this.$moment(now, "YYYY-MM-DD");
      this.getData();
    },
    // deleteJob(id) {
    //   this.DeleteJob({ id }).then(res => {
    //     this.$Message[res.status ? 'success' : 'error'](res.msg);
    //     if (!res.status) {
    //       return false;
    //     }
    //     this.getData();
    //   })
    // },
    delJobs() {
      if (!this.delIds.length) {
        this.$Message.error("请先选择删除项");
        return false;
      }
      this.$Modal.confirm({
        title: "重要提醒",
        content: "确认删除已选订单吗？",
        okText: "确定",
        onOk: () => {
          const ids = [...this.delIds];
          this.DeleteJob({ ids }).then((res) => {
            this.$Message[res.status ? "success" : "error"](res.msg);
            if (!res.status) {
              return false;
            }
            this.getData();
          });
        },
      });
    },
    handleSelection(rows) {
      const ids = [];
      rows.map((item) => {
        ids.push(item.id);
      });
      this.delIds = ids;
    },
    handlerErrorJobRefund() {
      if (!this.modalRefunds.data.pay_no) {
        this.$Message.error("请输入正确的订单号");
        return false;
      }
      this.RefundErrorJob({ pay_no: this.modalRefunds.data.pay_no }).then((res) => {
        if (res.code !== 200) {
          this.$Message.error(res.msg);
          return false;
        }
        this.$Message.success(res.msg);
        this.modalRefunds.data.pay_no = "";
        this.modalRefunds.visible = false;
      });
    },
    ...mapActions([
      "JobList",
      "JobTotalMoney",
      "WXReturnMoney",
      "RefundJob",
      "ALIReturnMoney",
      "JobReturnMoney",
      "JobOver",
      "DeleteJob",
      "RefundErrorJob",
      "GetMachineTypeGroup",
    ]),
  },
  computed: mapGetters({
    agent: "agent",
  }),
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
